export default __webpack_public_path__ + "static/media/ring.4d021b9b.mp3";